/**
 * @generated SignedSource<<7360e6fc76a34f33eccf67c5843562f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RegisterAccountContainerQuery$variables = {
  token: string;
  userContext?: string | null | undefined;
};
export type RegisterAccountContainerQuery$data = {
  readonly setPasswordToken: {
    readonly club: {
      readonly defaultLocale: string;
      readonly logoImage: {
        readonly format: string;
        readonly height: number;
        readonly publicId: string;
        readonly width: number;
      } | null | undefined;
      readonly name: string;
      readonly slug: string;
    };
    readonly email: string;
  } | null | undefined;
};
export type RegisterAccountContainerQuery = {
  response: RegisterAccountContainerQuery$data;
  variables: RegisterAccountContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userContext"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      },
      {
        "kind": "Variable",
        "name": "userContext",
        "variableName": "userContext"
      }
    ],
    "concreteType": "PasswordToken",
    "kind": "LinkedField",
    "name": "setPasswordToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UnauthenticatedClub",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defaultLocale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnauthenticatedImage",
            "kind": "LinkedField",
            "name": "logoImage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "format",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": "publicId",
                "args": null,
                "kind": "ScalarField",
                "name": "renderingKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegisterAccountContainerQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegisterAccountContainerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "419772b65cebfa134f7e90ee7bfd6ba7",
    "id": null,
    "metadata": {},
    "name": "RegisterAccountContainerQuery",
    "operationKind": "query",
    "text": "query RegisterAccountContainerQuery(\n  $token: String!\n  $userContext: String\n) {\n  setPasswordToken(token: $token, userContext: $userContext) {\n    email\n    club {\n      defaultLocale\n      name\n      slug\n      logoImage {\n        format\n        height\n        publicId: renderingKey\n        width\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2b8605727441e0a994c8c1a41682132";

export default node;
